export const getHostnameFromURL = (href: string) => {
  try {
    return new URL(href).hostname
  } catch {
    return ""
  }
}

export const getDomainFromURL = (href: string) =>
  getHostnameFromURL(href).replace(/^www\./, "")
